import { ConsentAwareContract } from '@/services/contracts/consent-aware.contract'
import appStore from '@/stores/app.store'
import accountStore from '@/stores/account.store'
import b2buserStore from '@/units/b2b/stores/b2buser.store'

class ProductFruitsService implements ConsentAwareContract {
  activate(): void | Promise<void> {
    this.loadScript()
  }

  deactivate(): void | Promise<void> {
    // TODO: implement deactivate method
  }

  private loadScript() {
    if (!appStore.state.productFruitLoaded) {
      const url = 'https://app.productfruits.com/static/script.js'
      const language = 'de'

      appStore.setProductFruitLoaded(true)

      const productFruitId =
        window.location.href.includes('enterprise') ||
        window.location.href.includes('/b2b') ||
        window.location.href.includes('unternehmensportal')
          ? import.meta.env.VITE_PRODUCT_FRUITS_CODE_B2B
          : import.meta.env.VITE_PRODUCT_FRUITS_CODE_B2C

      window.productFruitsUser = {
        username:
          accountStore.state.account?.productFruitsId ||
          accountStore.state.account?.uuid ||
          b2buserStore.state.user?.productFruitsId ||
          'no-uuid',
      }
      window.productFruits = window.productFruits || {}
      window.productFruits.language = language
      window.productFruits.code = productFruitId
      const a = document.getElementsByTagName('head')[0]
      const r = document.createElement('script')
      r.async = true
      r.src = url + '?c=' + productFruitId
      a.appendChild(r)
    }
  }
}

export default new ProductFruitsService()
